import { TaskCardType } from '../entities/task-card-type';
import type { TaskDetails } from '../entities/task-details';
import type { TaskPreview } from '../entities/task-preview';
import { TaskStatus } from '../entities/task-status';

export function canSubmitResetRequest(
  task: TaskPreview | TaskDetails,
  newStatus: TaskStatus,
): boolean {
  if (newStatus !== TaskStatus.DONE || task.cardType !== TaskCardType.ALERT) {
    return false;
  }

  return !isStale(task);
}

export function isStale(task: TaskPreview | TaskDetails): boolean {
  return task.cardType === TaskCardType.ALERT && Boolean(task.alert?.resolved);
}
